import React from 'react';

import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Card from 'react-toolbox/lib/card';
import CardBody from './CardBody';
import LeftPane from './layout/LeftPane';
import Logo from './Logo';

const LoginErrorView = props => {
  return (
    <LeftPane className="col-xs-12 col-sm-6">
      <Helmet title="Error" />
      <Card>
        <CardBody>
          <Logo />
          <p className="text--error">{props.error}</p>
        </CardBody>
      </Card>
    </LeftPane>
  );
};

LoginErrorView.propTypes = { error: PropTypes.string };
export default LoginErrorView;



// WEBPACK FOOTER //
// ./src/client/src/components/LoginErrorView.js